import _ from 'lodash'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { withVideoCheck } from '../../Proposal/Common/ProposalForm/Shared/util'

export const getListingWithVideosModels = listing => {
  let models = _.get(listing, 'models', [])
  const videos = _.get(listing, 'videos', [])
  const isNoModelsListing = listing.isNoModelsListing || _.isEmpty(models)
  if (isNoModelsListing) {
    models = [{
      sku: listing.sku,
      videos
    }]
  }

  models = models.map((model, index) => {
    const _hasSameSku = o => o.sku === _.get(model, 'sku')
    const modelVideos = _.get(model, 'videos', [])
    const firstIdxInList = _.findIndex(models, _hasSameSku)
    const lastIdxInList = _.findLastIndex(models, _hasSameSku)
    const duplicated = firstIdxInList !== lastIdxInList
    const editable = !duplicated || firstIdxInList === index
    return {
      ...model,
      videos: modelVideos,
      editable
    }
  })
  return { ...listing, models, isNoModelsListing }
}

export const getParamsList = (formValues, reviewStatus, duplicatedMap) => {
  const {
    applicant,
    listings = []
  } = formValues
  // 共用商品賣場不能修改所以預先剔除
  const filteredListings = _.filter(listings, listing => !(listing.id in duplicatedMap))
  const updateParamsList = _.map(filteredListings, listing => {
    const {
      models = [],
      isNoModelsListing,
      videos,
      proposal: {
        id: proposalId
      } = {}
    } = listing
    let convertedVideosParams
    if (isNoModelsListing) {
      // 無屬性賣場修改影片帶 videos
      const convertVideo = withVideoCheck(videos)
      convertedVideosParams = {
        videos: _.isEmpty(convertVideo[0]) ? [] : convertVideo
      }
    } else {
      // 單雙層屬性賣場修改影片帶 models
      convertedVideosParams = {
        models: models.map((model) => {
          const convertVideo = withVideoCheck(_.get(models, '[0].videos')) // 刪除為空影片格式:convertVideo=[{}]，一般空影片格式:convertVideo=[]
          return {
            ..._.pick(model, ['sku']),
            videos: _.isEmpty(convertVideo[0]) ? [] : convertVideo // 若videos是空的，需將convertVideo轉換為空陣列，才不會送出驗證失敗
          }
        })
      }
    }
    const convertedListing = {
      ..._.pick(listing, ['id']),
      ...convertedVideosParams
    }
    const updateParams = {
      reviewStatus,
      applicant,
      id: proposalId,
      type: PROPOSAL_TYPE.UPDATE_VIDEO,
      listing: convertedListing
    }
    return updateParams
  })
  return updateParamsList
}
